import React, { createContext, useContext, useRef } from 'react';

type Values = {
  toolbarMiddleRef: any;
  extraButtonsRef: any;
};

const RefsContext = createContext<Values>({} as Values);

export const useRefs = () => {
  const refs = useContext(RefsContext);
  return refs;
};

export default ({ children }: { children: React.ReactNode }) => {
  const extraButtonsRef = useRef(null);
  const toolbarMiddleRef = useRef(null);

  return <RefsContext.Provider value={{ extraButtonsRef, toolbarMiddleRef }}>{children}</RefsContext.Provider>;
};
